import { useLayoutEffect, useRef } from "react";
import { SKINS, SKIN_LABELS } from "../skin";
import ChipRow from "./chip-row";

// Horizontally centre `chip` inside its scroll row without moving any vertical
// ancestor (scrollIntoView would also nudge the sheet panel).
function scrollChipIntoRow(row, chip) {
  if (!row || !chip) return;
  const rowRect = row.getBoundingClientRect();
  const chipRect = chip.getBoundingClientRect();
  const delta =
    chipRect.left +
    chipRect.width / 2 -
    (rowRect.left + rowRect.width / 2);
  row.scrollLeft += delta;
}

// Shares the `.mood` slide-up sheet styling; Mood was just its first user.
export default function SkinSheet({
  open,
  skin,
  isProFeaturesLocked,
  debugMode = false,
  onSkinChange,
  onUpgradeClick,
}) {
  const chipsRef = useRef(null);
  const locked = !!isProFeaturesLocked && !debugMode;

  useLayoutEffect(() => {
    if (!open) return;
    const row = chipsRef.current;
    scrollChipIntoRow(row, row?.querySelector(".mood__chip--selected"));
  }, [open, skin]);

  const pick = (value) => {
    // Color stays reachable while locked; the rest is Pro.
    if (locked && value !== "color") {
      onUpgradeClick?.();
      return;
    }
    onSkinChange?.(value);
  };

  return (
    <div
      id="mood-sheet"
      className={`mood mood--skin${open ? " mood--open" : ""}`}
      aria-label="Skins"
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="content__title">Skins</div>
        <p className="mood__subtitle">Pick how the popup looks.</p>
      </div>

      <ChipRow chipsRef={(el) => { chipsRef.current = el; }}>
        {SKINS.map((value) => {
          const isSelected = skin === value;
          const isLocked = locked && value !== "color";
          return (
            <button
              key={value}
              type="button"
              className={`mood__chip${isSelected ? " mood__chip--selected" : ""}${
                isLocked ? " mood__chip--locked" : ""
              }`}
              onClick={() => pick(value)}
              aria-disabled={isLocked || undefined}
              aria-pressed={isSelected}
              title={SKIN_LABELS[value]}
              tabIndex={open ? 0 : -1}
            >
              <span className="mood__chip-name">{SKIN_LABELS[value]}</span>
            </button>
          );
        })}
      </ChipRow>
    </div>
  );
}
